import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MyCustomersComponent } from './my-customers/my-customers.component';
import { AccountsComponent } from './accounts/accounts.component';
import { ContactsComponent } from './contacts/contacts.component';
import { PartnerService } from '../../services/partner.service';
import { AccountDetailComponent } from './account-detail/account-detail.component';

@NgModule({
    declarations: [MyCustomersComponent, AccountsComponent, ContactsComponent, AccountDetailComponent],
    imports: [CommonModule, RouterModule],
    providers: [PartnerService],
    exports: [MyCustomersComponent, AccountsComponent, ContactsComponent]
})
export class PartnersModule { }
